import { timeToStr } from './util'

export const timeToNow = (time) => {
    const t = parseFloat(new Date - new Date(time * 1000)) / 1000
    let str
    if (t) {
        if (t > 60 && t < 3600) {
            str = `${parseInt(t / 60.0, 10)}分钟前`
        } else if (t >= 3600 && t < 86400) {
            str = `${parseInt(t / 3600.0, 10)}小时前`
        } else if (t >= 86400 && t < 86400 * 30) {
            str = `${parseInt(t / 86400.0, 10)}天前`
        } else if (t >= 86400 * 30 && t < 86400 * 365) {
            str = `${parseInt(t / (86400.0 * 30), 10)}个月前`
        } else if (t >= 86400 * 365) {
            str = `${parseInt(t / (86400.0 * 365), 10)}年前`
        } else {
            str = `${parseInt(t, 10)}秒前`
        }
    }
    return str
}

export const timeToCur = (timestamp, cur) => {
    let t   = parseInt(Math.abs(timestamp - cur))
    let str

    if (t) {
        if (t > 60 && t < 3600) {
            str = `${parseInt(t / 60.0, 10)}分钟`
        } else if (t >= 3600 && t < 86400) {
            str = `${parseInt(t / 3600.0, 10)}小时`
        } else if (t >= 86400 && t < 86400 * 30) {
            str = `${parseInt(t / 86400.0, 10)}天`
        } else if (t >= 86400 * 30 && t < 86400 * 365) {
            str = `${parseInt(t / (86400.0 * 30), 10)}个月`
        } else if (t >= 86400 * 365) {
            str = `${parseInt(t / (86400.0 * 365), 10)}年`
        } else {
            str = `${parseInt(t, 10)}秒`
        }
    }
    return str
}

export const getValue = (cur, types, key, value) => {
    for(const i in types) {
        if (types[i][key] == cur) {
            return types[i][value]
        }
    }
}

export const transTime =  (timestamp, format) => {
    let result = timeToStr(timestamp, format)
    return result
}

export const timeToDay = (timestamp, curTime) => {
    let time = new Date(timestamp * 1000)
    let t   = parseInt(Math.abs(timestamp - curTime))
    let weekday = ['周日', '周一', '周二', '周三', '周四', '周五', '周六']
    let str

    if (t) {
        if ( t < 86400) {
            str = '今天'
        } else {
            str = weekday[time.getDay()]
        }
    }

    return str
}

export const timeByRecharge = (timestamp, curTime) => {
    let t = parseInt(Math.abs(timestamp - curTime))
    let str

    if (t) {
        if (t < 86400) {
            str = timeToStr(timestamp, 'hh:mm')
        } else {
            str = timeToStr(timestamp, 'MM-dd')
        }
    }

    return str
}



// WEBPACK FOOTER //
// ./src/filters.js